import { Collapse, CollapseProps } from "antd";
import "./style.scss";
import { useState } from "react";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

type PropsType = {
  onChange?: (item: any) => void;
  items: CollapseProps["items"];
  iconPosition?: "end" | "left" | "right" | "start";
};

export const CustomCollapse = ({
  items,
  onChange,
  iconPosition = "end",
}: PropsType) => {
  const [activeKey, setActiveKey] = useState<any>(items?.[0]?.key);

  const handleChange = (key: string | string[]) => {
    if (key === activeKey || (Array.isArray(key) && !key.length)) {
      return;
    }
    if (onChange) {
      const keyName = Array?.isArray(key) ? key?.[0] : key;
      const finded = items?.find((item: any) => item?.key === keyName);
      onChange(finded);
    }

    setActiveKey(key);
  };

  return (
    <div className="custom_collapse">
      <Collapse
        accordion
        activeKey={activeKey}
        onChange={handleChange}
        ghost
        items={items}
        destroyInactivePanel
        expandIconPosition={iconPosition}
        expandIcon={({ isActive }) =>
          !isActive ? (
            <IoMdArrowDropright
              style={{ fontSize: 16, marginRight: 8, color: "#677788" }}
            />
          ) : (
            <IoMdArrowDropdown
              style={{ fontSize: 16, marginRight: 8, color: "#677788" }}
            />
          )
        }
      />
    </div>
  );
};
